// Shared by browser upload preparation and the authoritative storage boundary.
export const PRODUCT_IMAGE_POLICY = {
    maxSourceBytes: 10 * 1024 * 1024,
    maxSourcePixels: 40_000_000,
    maxWidth: 1440,
    maxHeight: 5760,
    maxPixels: 4_147_200,
    targetBytes: 450 * 1024,
    maxBytes: 1536 * 1024,
    quality: 0.84,
    minimumQuality: 0.78,
};
export function productImageDimensions(width, height) {
    if (!Number.isFinite(width) ||
        !Number.isFinite(height) ||
        width < 1 ||
        height < 1 ||
        width * height > PRODUCT_IMAGE_POLICY.maxSourcePixels) {
        throw new Error('图片像素过大或尺寸无效，请选择 4000 万像素以内的图片');
    }
    const scale = Math.min(1, PRODUCT_IMAGE_POLICY.maxWidth / width, PRODUCT_IMAGE_POLICY.maxHeight / height, Math.sqrt(PRODUCT_IMAGE_POLICY.maxPixels / (width * height)));
    return {
        width: Math.max(1, Math.floor(width * scale)),
        height: Math.max(1, Math.floor(height * scale)),
    };
}
//# sourceMappingURL=product-image-policy.js.map